import React, {useState, useEffect, useRef, useContext} from 'react';
import { getItem } from '_services/agent';
import util from '../../common/util.js'
import { useSetRoute } from '_context/commonHooks';
import {MapContext} from '_context/MapContext';
import {ollehModule} from '../../common/mapAPIExport'

const MapRightClick = (props) => {
    const [menuShow, setMenuShow] = useState('none');
    const left = useRef('0px') 
    const top = useRef('0px') 
    const coord = useRef() 
    const [setRoute] = useSetRoute()
    const {ktMapIns, poiResult} = useContext(MapContext);

    useEffect(() => {
        if(ktMapIns){
            ktMapIns.onEvent('rightclick', function(e) {
                e.stopPropagation();
                e.preventDefault();
                if(e.targetDOM.parentNode.id==="mapArea"){
                    setMenuShow('none')
                    positionAdjustment(e)
                    setMenuShow('block')
                }
                return false;
            });
            ktMapIns.onEvent('idle', function(event) {
                setMenuShow('none')
            });
            ktMapIns.onEvent('click', function(event) {
                setMenuShow('none')
            });
        }
    }, [ktMapIns]);

    const positionAdjustment = (event) =>{
        let width = 120
        let height = 300
        var adjustment = {x:event.pageXY.x, y:event.pageXY.y};
        if((event.pageXY.x+width) > window.screen.availWidth){
            adjustment.x = adjustment.x - ((event.pageXY.x+width) - window.screen.availWidth) - 4;
        }
        if((event.pageXY.y+height) > window.screen.availHeight){
            adjustment.y = adjustment.y - ((event.pageXY.y+height) - window.screen.availHeight) - 4;
        }
        left.current = adjustment.x
        top.current = adjustment.y
        coord.current = event.getCoord()
    }
    
    async function reverseGeocode(target){
        let point = ollehModule.maps.LatLng.valueOf(coord.current);
        await getItem('geocode','?point.lat='+point.y+'&point.lng='+point.x, null, 'GET')
        .then(res => {
            let placeAdddres = null
            let roadAddress = null
            if(res.data.residentialAddress && res.data.residentialAddress.length>0){
                if(res.data.residentialAddress[0].parcelAddress && res.data.residentialAddress[0].parcelAddress.length>0){
                    placeAdddres = res.data.residentialAddress[0].parcelAddress[0]
                }
                if(res.data.residentialAddress[0].roadAddress && res.data.residentialAddress[0].roadAddress.length>0){
                    roadAddress = res.data.residentialAddress[0].roadAddress[0]
                }
                if(target=='thisPointAddress'){ 
                    props.thisPointAddressHandler(placeAdddres, roadAddress, point, coord.current)
                }else if(target=='thisPointResearch'){ 
                    if(poiResult){
                        props.thisPointResearchHandler(placeAdddres, roadAddress, point, coord.current)
                    }
                }else{
                    //setRoute(target, placeAdddres.fullAddress, placeAdddres.geographicInformation.point, 'add'); 
                    setRoute(target, placeAdddres.fullAddress, {lng:point.x, lat: point.y}, 'add'); 
                }
            }
        })
        .catch(err => {})
    }

    const currentLocation = ()=>{
        // window.localStorage.setItem('GIS_ME_CENTER', JSON.stringify({x:1000, y:1000}));
        // window.localStorage.setItem('GIS_ME_ZOOM', ktMapIns.getZoom());
        // window._map.getOverlayLayer().layerMgr.getCoordFromViewportPx(new olleh.maps.Point(0,0))
    }

    return (
        <div className="mouseMenu" style={{zIndex:100, top:top.current, left:left.current, display:menuShow}}>
            <ul>
                <li><a href="#" onClick={(e) => reverseGeocode('thisPointAddress')}><span className="btnsMouseMenu ic1"></span>이 위치 주소보기</a></li>
                <li><a href="#" onClick={(e) => reverseGeocode('thisPointResearch')}>
                        <span className="btnsMouseMenu ic2"></span>
                        <font style={{textDecoration:poiResult?'':'line-through', cursor:'pointer'}}>이 위치 재검색</font>
                    </a>
                </li>
                {/* <li><a href="javascript:void(0)" onClick={(e) => currentLocation()}><span className="btnsMouseMenu ic3"></span>내 위치로 지정</a></li> */}
            </ul>
            <ul>
                <li><a href="#" onClick={(e) => reverseGeocode('start')}><span className="btnsMouseMenu ic4"></span>출발지로 지정</a></li>
                <li><a href="#" onClick={(e) => reverseGeocode('end')}><span className="btnsMouseMenu ic5"></span>도착지로 지정</a></li>
                <li><a href="#" onClick={(e) => reverseGeocode('wayPoints')}><span className="btnsMouseMenu ic6"></span>경유지로 지정</a></li>
            </ul>
            <ul>
                <li><a href="#"><span className="btnsMouseMenu ic7"></span>신규 장소등록</a></li>
            </ul>
        </div>
    )
}

export default MapRightClick;